/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MailMagazineManagementAddFileUploadRequest } from '../models/MailMagazineManagementAddFileUploadRequest';
import type { MailMagazineManagementAddFileUploadResponseApiRespoonse } from '../models/MailMagazineManagementAddFileUploadResponseApiRespoonse';
import type { MailMagazineManagementCreateMailMagazineRequest } from '../models/MailMagazineManagementCreateMailMagazineRequest';
import type { MailMagazineManagementCreateMailMagazineResponseApiRespoonse } from '../models/MailMagazineManagementCreateMailMagazineResponseApiRespoonse';
import type { MailMagazineManagementDeleteMailMagazineRequest } from '../models/MailMagazineManagementDeleteMailMagazineRequest';
import type { MailMagazineManagementDeleteMailMagazineResponseApiRespoonse } from '../models/MailMagazineManagementDeleteMailMagazineResponseApiRespoonse';
import type { MailMagazineManagementEditMailMagazineRequest } from '../models/MailMagazineManagementEditMailMagazineRequest';
import type { MailMagazineManagementEditMailMagazineResponseApiRespoonse } from '../models/MailMagazineManagementEditMailMagazineResponseApiRespoonse';
import type { MailMagazineManagementListMailMagazineRequest } from '../models/MailMagazineManagementListMailMagazineRequest';
import type { MailMagazineManagementListMailMagazineResponseApiRespoonse } from '../models/MailMagazineManagementListMailMagazineResponseApiRespoonse';
import type { MailMagazineManagementListSenderRequest } from '../models/MailMagazineManagementListSenderRequest';
import type { MailMagazineManagementListSenderResponseApiRespoonse } from '../models/MailMagazineManagementListSenderResponseApiRespoonse';
import type { MailMagazineManagementShowMailMagazineRequest } from '../models/MailMagazineManagementShowMailMagazineRequest';
import type { MailMagazineManagementShowMailMagazineResponseApiRespoonse } from '../models/MailMagazineManagementShowMailMagazineResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MailMagazineManagementService {

    /**
     * Get list MailMagazine
     * @param requestBody
     * @returns MailMagazineManagementListMailMagazineResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMailMagazine(
        requestBody: MailMagazineManagementListMailMagazineRequest,
    ): CancelablePromise<MailMagazineManagementListMailMagazineResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/mail-magazine',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Show MailMagazine
     * @param requestBody
     * @returns MailMagazineManagementShowMailMagazineResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMailMagazineShow(
        requestBody: MailMagazineManagementShowMailMagazineRequest,
    ): CancelablePromise<MailMagazineManagementShowMailMagazineResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/mail-magazine/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Create MailMagazine
     * @param requestBody
     * @returns MailMagazineManagementCreateMailMagazineResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMailMagazineCreate(
        requestBody: MailMagazineManagementCreateMailMagazineRequest,
    ): CancelablePromise<MailMagazineManagementCreateMailMagazineResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/mail-magazine/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Edit MailMagazine
     * @param requestBody
     * @returns MailMagazineManagementEditMailMagazineResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMailMagazineEdit(
        requestBody: MailMagazineManagementEditMailMagazineRequest,
    ): CancelablePromise<MailMagazineManagementEditMailMagazineResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/mail-magazine/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Delete MailMagazine
     * @param requestBody
     * @returns MailMagazineManagementDeleteMailMagazineResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMailMagazineDelete(
        requestBody: MailMagazineManagementDeleteMailMagazineRequest,
    ): CancelablePromise<MailMagazineManagementDeleteMailMagazineResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/mail-magazine/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ファイルアップロード
     * @param requestBody
     * @returns MailMagazineManagementAddFileUploadResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMailMagazineFileUpload(
        requestBody: MailMagazineManagementAddFileUploadRequest,
    ): CancelablePromise<MailMagazineManagementAddFileUploadResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/mail-magazine/file-upload',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * list sender
     * @param requestBody
     * @returns MailMagazineManagementListSenderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMailMagazineSender(
        requestBody: MailMagazineManagementListSenderRequest,
    ): CancelablePromise<MailMagazineManagementListSenderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/mail-magazine/sender',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
